import React, { FunctionComponent, useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend,  Label } from 'recharts';
import moment from 'moment';
import '../../stations/Station.scss';
import { ONEDAY } from 'src/store/common';

type SFChartProps = {
    all_dates: any[]
}
const CustomizedAxisTick: FunctionComponent<any> = (props: any) => {
  const { x, y, payload } = props;
  return (
    <g transform={`translate(${x},${y})`} >
      <text
        fontSize=".75rem"
        x={0}
        y={2}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)"
      >
        {moment(payload.value).format('MMM DD')}
      </text>
    </g>
  );
};
const CustomTooltip:FunctionComponent = (props:any) => {
  const {active, label,payload}=props;
  
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip" style={{backgroundColor: 'white', border: 'none !important', display:'block', margin:'3px', padding: '3px', height:'3.25rem'}}>
        <span className="month" style={{fontSize: '.75rem', paddingBottom: '0px', paddingTop:'0px', display:'block'}}>
        {moment(label).format("MMM DD, YYYY")}
        </span>
        <svg width="50" height="10" style={{display: 'block', paddingTop: '0px', paddingBottom: '0px'}}>
          <rect width="5" height="5" style={{fill:'#4C4E4E'}}/>
          <text
            fontSize=".75rem"
            height="5"
            x={10}
            y={10}
          >
          {payload[0] && payload[0].value ?`${payload[0].value}`:'0'}
        </text>
        </svg>
      </div>
    );
  }
  return null;
};
export const SFChart: React.FC<SFChartProps> = ({all_dates}) => {
  const [xTicks, setXTicks] = useState<number[]>([]);
  useEffect(()=>{
    if(all_dates.length>1){
      let ticks:number[]=[];

      if(ticks.length<1){
        let i = moment(all_dates[0].date).format('MMM DD');
        ticks.push(all_dates[0].date)
        let j=0;
        while(i !== moment(all_dates.at(-1).date).format('MMM DD')){          
          j=j+1;
          ticks.push(all_dates[0].date + j*ONEDAY)
          i = moment(all_dates[0].date + j*ONEDAY).format('MMM DD')
        }
        setXTicks(ticks)
      }
  
    }
  },[all_dates]);   

  return(
    <>
    {all_dates.length>1&&(
        <LineChart
          width={400}
          height={150}
          data={all_dates}
          margin={{
            top: (5),
            right: 10,
            left: 10,
            bottom: 10,
          }}
        >
          <XAxis dataKey="date" interval={0} type="number" tick={<CustomizedAxisTick />} domain={[all_dates.at(-1).date, all_dates[0].date]} ticks={xTicks}/>          
          <YAxis yAxisId="left" orientation="left" domain={[-0.5,1]} style={{fontSize: '0.7rem',fontFamily: 'serif'}} ticks={[0,1]} axisLine={false}>
          <Label
            value={'Snow Flag'}
            position="insideLeft"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle' }}
          />
          </YAxis>
          <Tooltip content={<CustomTooltip />} position={{ y: -5 }} />
          <Legend wrapperStyle={{fontSize:'11px', top:'140px'}} iconType="plainline" iconSize={10}/>
          <Line name={'Snow Flag'} type="monotone" yAxisId ="left" dataKey="valObs" stroke="#4C4E4E" dot={ false} strokeWidth={2}/>
          <Line name={'Snow Flag Forecast'}  type="monotone" yAxisId = "left" dataKey="valF" stroke="#4C4E4E" dot={false} strokeDasharray="5 5" strokeWidth={2}/>
        </LineChart>
    )
    }
    </>

  );
}